module.exports = "<aside class=\"aside-menu\">\n</aside>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/midac/midac-live/app/src/app/components/app-aside/app-aside.component.html
// module id = ../../../../../src/app/components/app-aside/app-aside.component.html
// module chunks = main